<template>
  <CollapsibleRoot
    :defaultOpen="defaultOpen"
    :open="localOpen"
    @update:open="
      (value: boolean) => {
        localOpen = value;
        $emit('update:open', value);
      }
    "
    class="CollapsibleRoot"
  >
    <!-- title/trigger section -->
    <div class="flex justify-between items-center">
      <!-- left content -->
      <slot name="left" />
      <!-- collapse arrow -->
      <CollapsibleTrigger class="CollapsibleTrigger">
        <w-icon-button icon="ph:caret-down-fill" class="icon-button" no-border />
      </CollapsibleTrigger>
      <!-- right content -->
      <slot name="right" />
    </div>

    <!-- for any content you want to be visible by default -->
    <slot />

    <CollapsibleContent class="CollapsibleContent">
      <slot name="content" />
    </CollapsibleContent>
  </CollapsibleRoot>
</template>

<script lang="ts">
  import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from 'radix-vue';

  export default {
    name: 'WCollapsible',
    emits: ['update:open'],
    components: { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger },
    props: {
      open: {
        type: Boolean,
        default: true,
      },
      defaultOpen: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        localOpen: this.open,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';

  .CollapsibleRoot {
    width: 100%;
  }

  .CollapsibleTrigger {
    background-color: transparent;
    .icon-button {
      scale: 0.8;
      color: $input-placeholder;
      transition: all 0.2s;
    }
  }

  .CollapsibleTrigger[data-state='open'] {
    .icon-button {
      transform: rotate(180deg);
    }
  }

  .CollapsibleContent[data-state='open'] {
    animation: slideDown 300ms ease-out;
  }
  .CollapsibleContent[data-state='closed'] {
    animation: slideUp 300ms ease-out;
  }

  @keyframes slideDown {
    from {
      height: 0;
      opacity: 0;
    }
    to {
      height: var(--radix-collapsible-content-height);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      height: var(--radix-collapsible-content-height);
      opacity: 1;
    }
    to {
      height: 0;
      opacity: 0;
    }
  }
</style>
